<template>
  <div class="container-fluid">
    <div class="wrapper">
      <!-- Header -->
      <div class="header__logo">
        <div class="container">
          <a href="/" class="header__logo-link">
            <img
              class="header__logo-image"
              style=""
              src="//cdn.shopify.com/s/files/1/0596/1547/7862/files/logo-aozama-blanco.png?width=280&height=132"
              alt="Aozama"
            />
          </a>
        </div>
      </div>

      <!-- Container -->
      <div class="container home-offers">
        <div class="content">
          <div class="home-offer__content">
            <!-- Search Bar -->
            <div class="search-bar-form row m-0">
              <!-- Search Bar Form -->
              <input
                type="search"
                class="search-bar-form__input form-control"
                name="search"
                placeholder="Busca un producto aquí"
                v-model="search"
              />

              <!-- Search Bar Dropdown -->
              <div class="search-bar-dropdown">
                <div class="search-bar-dropdown__categories content-input">
                  <select
                    class="form-control search-bar-dropdown__select"
                    id=""
                    v-model="search_category_id"
                  >
                    <option
                      v-for="category in categories"
                      value="{{category.id}}"
                    >
                      {{ category.name }}
                    </option>
                  </select>
                </div>
              </div>

              <!-- Search Bar Button -->
              <div
                class="search-bar-form__button base-button accept-btn"
                @click="searchAll()"
              >
                BUSCAR
              </div>
            </div>

            <!-- Home Offers Sliders -->
            <div class="home-offer__sliders row m-0">
              <!-- Offers Slide 1 -->
              <div
                class="
                  col
                  offer--cards offer--cards__bg
                  offer--card__slide
                  mr-20
                "
              >
                <h2>Las mejores ofertas</h2>
                <div class="best-offers" v-show="bestOffers.length > 0">
                  <div
                    class="devices--list__container"
                    v-for="top in bestOffers"
                  >
                    <div class="devices--list__image">
                      <a href="/#!/product-detail/{{top.id}}"
                        ><img src="{{ top.image }}"
                      /></a>
                    </div>
                    <div class="devices--list__content">
                      <div class="devices--list__price">
                        <sub class="sign-price">RD$</sub>
                        <span class="currency-price">{{
                          top.price | currency
                        }}</span>
                      </div>
                      <h4>
                        <a href="/#!/product-detail/{{top.id}}">{{
                          top.name
                        }}</a>
                      </h4>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Promo Slide 2 -->
              <div class="col offer--cards offer--cards__bg offer--card__Promo">
                <h2>Promociones</h2>
                <div class="promotion" v-show="promotions.length > 0">
                  <div
                    class="devices--list__image"
                    v-for="promotion in promotions"
                  >
                    <img
                      src="https://api.cashdepotint.com/{{promotion.image}}"
                    />
                  </div>
                </div>

                <!-- <div class="devices--list__content">
                                    <div class="devices--list__price">
                                        <sub class="sign-price">RD$</sub> 
                                        <span class="currency-price">22,500</span> 
                                        <sub class="cent-price">.00</sub>
                                    </div>
                                    <h4>Samsung Galaxy S9 Plus</h4>
                                </div> -->
              </div>
            </div>

            <!-- Product Category Slider -->
            <div
              class="
                product-category__sliders
                sliders--title
                row
                m-0
                padding--section
              "
            >
              <h3>Categorias de productos</h3>
              <!-- Slide Category -->
              <div class="splide">
                <div class="splide__track">
                  <ul class="splide__list kenwheeler">
                    <li class="splide__slide" v-for="category in categories">
                      <a
                        href="/#!/brand-list/{{category.id}}"
                        class="splide__slide__container border-line"
                      >
                        <img
                          src="{{category.image ?? '/images/offes-news-img/ct-categoria-no-disponible.jpg' }}"
                        />
                      </a>
                      <span>
                        <a href="/#!/brand-list/{{category.id}}">
                          {{ category.name }}
                        </a>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Marcas destacadas Slider -->
            <div
              class="
                product-category__sliders
                sliders--title
                row
                m-0
                padding--section
              "
            >
              <h3>Marcas destacadas</h3>
              <!-- Slide Brand List -->
              <div class="splide">
                <div class="splide__track">
                  <ul class="splide__list kenwheeler">
                    <li class="splide__slide" v-for="brand in brands">
                      <a
                        href="/#!/types-of-brands/{{brand.id}}"
                        class="splide__slide__container border-line"
                      >
                        <img
                          src="{{brand.image ?? '/images/offes-news-img/ct-marca-no-disponible.jp' }}"
                        />
                      </a>
                      <span>
                        <a href="/#!/brand-list/{{category.id}}">
                          {{ brand.name }}
                        </a>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Top offers Slider -->
            <div
              class="
                top-offers__sliders
                sliders--title
                row
                m-0
                padding--section
              "
            >
              <h3>Ofertas destacadas</h3>
              <!-- Slide Top Offers -->
              <div class="splide">
                <div class="splide__track">
                  <ul class="splide__list tops">
                    <li class="splide__slide" v-for="article in tops">
                      <a
                        href="/#!/product-detail/{{article.id}}"
                        class="splide__slide__container"
                      >
                        <img :src="article.image" />
                      </a>
                      <span>{{ article.name }}</span>
                      <label class="top-offers__price currency-price"
                        >RD$ {{ article.price | currency }}</label
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Reliable Providers Slider -->
            <div
              class="providers__slider sliders--title row m-0 padding--section"
            >
              <h3>Proveedores confiables</h3>
              <!-- Slide Top Providers -->
              <div class="providers-splide splide">
                <div class="splide__track">
                  <ul class="splide__list providers-slider">
                    <li
                      class="providers splide__slide"
                      v-for="provider in providers"
                    >
                      <a
                        href="/#!/by-provider/{{provider.id}}"
                        class="providers-slide__content"
                      >
                        <img
                          src="{{ provider.logo ?? '/images/offes-news-img/logo.png' }}"
                        />
                      </a>
                      <span>{{ provider.name }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vue from "vue";
import router from "vue-router";

vue.use(router);

export default {
  name: "HomeOffers",
  referTo: "/home-offers",
  data: () => {
    return {
      categories: [],
      brands: [],
      tops: [],
      promotions: [],
      bestOffers: [],
      providers: [],
      search: "",
      search_category_id: 1,
    };
  },
  methods: {
    topOffers() {
      this.$http.get(apiUrl + "/offers/tops").then((response) => {
        this.tops = response.data;
        if (this.tops.length > 5) {
          this.$nextTick(() => {
            this.startSlick(".tops", 5);
          });
        }
      });
    },
    getBestOffers() {
      this.$http.get(apiUrl + "/offers/promotions").then((response) => {
        this.bestOffers = response.data;
        if (this.bestOffers.length > 1) {
          this.$nextTick(() => {
            this.startSlick(".best-offers", 1);
          });
        }
      });
    },
    promotion() {
      this.$http.get(apiUrl + "/promotions").then((response) => {
        this.promotions = response.data;
        if (this.promotions.length > 1) {
          this.$nextTick(() => {
            this.startSlick(".promotion", 1);
          });
        }
      });
    },
    getCategories() {
      this.$http.get(apiUrl + "/offers/dashboard").then((response) => {
        this.categories = response.data;
        if (this.categories.length > 5) {
          this.$nextTick(() => {
            this.startSlick(".kenwheeler");
          });
        }
      });
      //this.$http.get(apiUrl + "/categories").then((response) => {
      // this.$http.get(apiUrl + "/service-types").then((response) => {
      //   this.categories = response.data;
      //   this.$nextTick(() => {
      //     this.startSlick(".kenwheeler");
      //   });
      // });
    },
    startSlick(slickContainer, total = 5) {
      $(slickContainer).slick({
        lazyLoad: "ondemand",
        slidesToShow: total,
        slidesToScroll: 1,
        infinite: true,
        speed: 300,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    },
    getBrands() {
      this.$http.get(apiUrl + "/brands/availables").then((response) => {
        this.brands = response.data;
        if (this.brands.length > 5) {
          this.$nextTick(() => {
            this.startSlick(".kenwheeler");
          });
        }
      });
    },
    getProviders() {
      this.$http.get(apiUrl + "/providers/availables").then((response) => {
        this.providers = response.data;
        if (this.providers.length > 5) {
          this.$nextTick(() => {
            this.startSlick(".providers-slider");
          });
        }
      });
    },
    searchAll() {
      window.location.replace(
        "/#!/brand-list/" +
          this.search_category_id +
          "?sort=best-selling&q=" +
          this.search
      );
    },
  },
  async created() {
    this.id = this.$route.query.id;
    this.employee_id = this.$route.query.employee_id;
    if (this.id) {
      window.localStorage.setItem("user_id", this.id);
      window.localStorage.setItem("employee_id", this.employee_id);
    }

    this.getCategories();
    this.getBrands();
    this.topOffers();
    this.promotion();
    this.getProviders();
    this.getBestOffers();
  },
};
</script>

<style lang="css" scoped>
img {
  max-width: 100%;
}
h1 {
  font-size: 26px;
}
.mr-20 {
  margin-right: 20px;
}

a {
  color: #213f99;
  border: none;
}
a:hover {
  text-decoration: underline;
  color: #213f99;
}

.container-fluid {
  padding: 0px;
}

/* Header */
.header__logo {
  background-color: #1e2d7d;
  max-height: 90px;
}

.header__logo a {
  display: block;
}

.header__logo-image {
  width: 180px;
}

.padding--section {
  padding: 25px 0;
}
.border-line {
  border: 1px solid #e7e7e7;
}
/* Button */
.base-button {
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 40px;
  text-transform: uppercase;
  font-weight: 800;
  font-size: 14px;
  letter-spacing: 1px;
  cursor: pointer;
  text-align: center;
  word-break: keep-all;
  transition: all 0.3s;
}

.accept-btn {
  background-color: #38b449;
  color: #fff;
}
.accept-btn:hover {
  background-color: #1e2d7d;
}

.home-offer__content {
  padding-bottom: 50px;
}

.home-offer__sliders,
.search-bar-form {
  display: flex;
}

.search-bar-form {
  margin-bottom: 20px;
  margin-top: 40px;
}

.search-bar-form form {
  width: 100%;
}
.search-bar-form__input {
  width: 65%;
  float: left;
}
.search-bar-dropdown {
  width: 23%;
  float: left;
}
.search-bar-form__button {
  width: 10%;
  height: 42px;
  float: right;
}

/* Product Category Slide */
.sliders--title h3 {
  padding-bottom: 15px;
  margin: 20px 0;
  border-bottom: 1px solid #ddd;
}

.splide__list {
  display: flex;
}
.splide__slide {
  margin: 0 10px;
  text-align: center;
}

.splide__slide span {
  font-size: 16px;
  display: inline-block;
  color: #1e2d7d;
}

.splide__slide__container {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
  font-size: 14px;
}

/* Top Slider */
.top-offers__sliders ul {
  background: #fff;
  border-bottom: 1px solid #f5f5f5;
  border-top: 1px solid #f5f5f5;
}

.top-offers__sliders ul li {
  border-left: 1px solid #f5f5f5;
  border-right: 1px solid #f5f5f5;
  margin: 0;
  padding: 15px;
  max-width: 228px;
  width: 100%;
}

/* Offer Style */
.offer--card__slide img {
  max-height: 200px;
}

/* Offer Style Promo */
.offer--card__Promo img {
  max-height: max-content;
  margin: 0 auto;
}

.offer--title h1 {
  font-weight: bold;
}
.offer--title a {
  display: block;
  margin: 30px 0px 20px;
  text-align: right;
}
.offer--title .col-lg-2,
.offer--title .col-lg-10 {
  padding-left: 0px;
  padding-right: 0px;
}
.offer--cards__bg {
  background: #fff;
  border: 1px solid #ccc;
  padding: 15px 20px;
}
.offer--cards {
  width: 50%;
  min-height: 300px;
  text-align: center;
}
.offer--cards h3 {
  margin-top: 20px;
}
.offer--cards h4 {
  margin-top: 0px;
}
.offer--cards p {
  font-size: 18px;
  margin-top: 30px;
  color: #42494b;
}
.offer--cards a {
  display: block;
  margin-top: 15px;
  margin-bottom: 15px;
}
.sign-price,
.currency-price {
  vertical-align: middle;
  color: #cf3917;
}
.currency-price {
  font-size: 24px;
  color: #cf3917;
  padding: 10px 0;
}
.cent-price {
  vertical-align: sub;
  margin-left: -5px;
  color: #cf3917;
}

/* Providers Slider */
.providers-slide__content {
  width: 210px;
  height: 210px;
  display: flex;
  margin-bottom: 30px;
}
.providers-slide__content img {
  border-radius: 100px;
}
.devices--list__image {
  display: flex;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// home-offers.vue?5807ac54